"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operatorJobsDetails = void 0;
exports.operatorJobsDetails = [
    { code: 'MANAGER', label: 'Manager' },
    { code: 'SECTOR_SUPERVISOR', label: 'Responsable de secteur' },
    { code: 'BOOKER', label: 'Booker' },
    { code: 'MONITORING', label: 'Monitor' },
    { code: 'OFF_PROD', label: 'Hors prod' },
];
